import axios from "axios";
import { LIVE_CHAT_LIMITS } from "../constants";
import { resolveApiUrl } from "../utils/liveChatUrls";

export class LiveChatApiError extends Error {
  constructor(response) {
    super("Live chat request failed");
    this.name = "LiveChatApiError";
    this.status = response?.status || 0;
    this.payload = response?.data || null;
    this.retryAfter = Number(response?.headers?.["retry-after"]) || null;
  }
}

function authConfig(staffToken, withCredentials) {
  return {
    withCredentials: withCredentials,
    headers: staffToken ? { Authorization: `jwt ${staffToken}` } : undefined,
  };
}

async function unwrap(request) {
  try {
    const response = await request;
    if (!response.data?.success) throw new LiveChatApiError(response);
    return response.data.data;
  } catch (error) {
    if (error instanceof LiveChatApiError) throw error;
    if (axios.isAxiosError(error)) throw new LiveChatApiError(error.response);
    throw error;
  }
}

export function bootstrapLiveChat({
  url,
  body,
  baseUrl,
  staffToken,
  withCredentials = false,
}) {
  return unwrap(
    axios.post(resolveApiUrl(url, baseUrl), body, authConfig(staffToken, withCredentials))
  );
}

export function sendLiveChatMessage({ url, token, clientMessageId, message, baseUrl }) {
  return unwrap(
    axios.post(resolveApiUrl(url, baseUrl), {
      token,
      client_message_id: clientMessageId,
      message,
    })
  );
}

export function getLiveChatHistory({ url, token, beforeId, limit, baseUrl, signal }) {
  return unwrap(
    axios.get(resolveApiUrl(url, baseUrl), {
      params: { token, limit, ...(beforeId ? { before_id: beforeId } : {}) },
      signal,
      timeout: LIVE_CHAT_LIMITS.historyRequestTimeoutMs,
    })
  );
}

export function sendLiveChatOtp({ url, token, phone, baseUrl }) {
  return unwrap(axios.post(resolveApiUrl(url, baseUrl), { token, phone }));
}

export function verifyLiveChatOtp({ url, token, phone, otp, baseUrl }) {
  return unwrap(axios.post(resolveApiUrl(url, baseUrl), { token, phone, otp }));
}

export function hasApiError(error, key) {
  return Boolean(error?.payload?.error?.[key]);
}

export function getApiErrorMessage(error) {
  const errors = error?.payload?.error;
  if (!errors || typeof errors !== "object") return null;
  const firstValue = Object.values(errors).find((value) => Array.isArray(value) && value[0]);
  return firstValue?.[0] || null;
}

